import { TemplatePage } from './types';

const christmasPage: TemplatePage = {
  header: {
    color: '#F1F6FA',
    icon: 'images/video-templates/christmas.jpg',
    title: 'Christmas templates',
    title_meta: 'Easily Customizable Christmas Video Templates',
    description_meta:
      'A great collection of Christmas free video templates will help you ' +
      'to create a fun and magic-filled holiday season. Select from greetings, ' +
      'fun facts, promos, ads, sales, special offer videos, and more to create ' +
      'lasting memories and bring the magic of Christmas to your community.',
    description:
      'Give a creative twist to your greetings, fun facts, promos, sales, special offer ' +
      'videos, and more with Wave.video’s easily personalizable Christmas video templates.'
  },
  footer: {
    category: 'christmas',
    description:
      'Christmas is a great time to remind your loved ones and your clients about yourself, ' +
      'your services, and your products. Do exactly that with video this year! Pick from video ' +
      'templates that serve your goal and your style best. <br>Easily personalize and customize ' +
      'our video Christmas templates, send them in email, on social media, take advantage of fun ' +
      'or lyric video ads - make beautiful videos in minutes. With Wave.video it’s as easy as 1-2-3!'
  },
  content: [
    {
      type: 'templates',
      title: 'Christmas templates',
      search: { category: '/Holidays & Occasions/Christmas' }
    },
    {
      type: 'stocks',
      title: 'Christmas',
      search: { name: 'christmas' }
    },
    { type: 'calendar' }
  ]
};

export default christmasPage;
